const RejectedSupplierDetail = () => {
    return (
        <div className="container-fluid h-100 d-flex p-0 column-gap-3" style={{ borderRadius: '6px' }}>

        </div>
    )
}

export default RejectedSupplierDetail